import { useQuery } from "@apollo/client";
import { graphql } from "gql/apollo";

export const GetContactGroup = graphql(/* GraphQL */ `
	query GetContactGroup($params: GetContactGroupParams!) {
		getContactGroup(params: $params) {
			name
		}
	}
`);

export const useGetContactGroup = (gid?: GID) => {
	const { data, loading, error } = useQuery(GetContactGroup, {
		variables: {
			params: {
				gid: gid as GID,
			},
		},
		skip: !gid,
	});

	return {
		name: data?.getContactGroup?.name,
		loading,
		error,
	};
};
